import { Star, StarBorder } from '@mui/icons-material';
import { cyan, green, grey, orange, yellow } from '@mui/material/colors';
import SkeletonThumb from 'components/SchoolsComponents/SchoolGalleryComponent/SkeletonThumb';

import StarHalfIcon from '@mui/icons-material/StarHalf';

import {
  formatDate,
  getDaysAdded,
  getDaysSubtracted,
  getNextBusinessDayInRange,
  getGroupedMondayOptions,
  getNextWeekDay,
  getWeeksAdded,
  isValidDate,
} from 'utils/date';

export const getSchoolDefaultDates = (params, weeks) => {
  const FRIDAY = 5;
  const validWeekQuantity = weeks.some(
    (w) => w === parseInt(params.weeksQuantity, 10)
  );
  const courseWeeks = validWeekQuantity
    ? parseInt(params.weeksQuantity, 10)
    : weeks[0];
  const courseStart = params.startDate
    ? new Date(params.startDate.replace(/-/g, '/'))
    : getNextBusinessDayInRange(
        getDaysAdded(new Date(), parseInt(process.env.DAYS_BEFORE_BOOKING, 10))
      );
  const courseEnd = getNextWeekDay(
    getWeeksAdded(courseStart, courseWeeks),
    FRIDAY
  );
  const accommodationStart = getDaysSubtracted(courseStart, 1);
  const accommodationEnd = getDaysAdded(courseEnd, 1);

  return {
    courseStart,
    courseEnd,
    courseWeeks,
    accommodationStart,
    accommodationEnd,
  };
};

export const createStars = (rate, color, starFontSize = 'medium') => {
  const result = [];

  for (let i = 1; i <= 5; i++) {
    if (i <= rate)
      result.push(<Star key={i} fontSize={starFontSize} sx={{ color }} />);
    else
      result.push(
        <StarBorder key={i} fontSize={starFontSize} sx={{ color }} />
      );
  }

  return result;
};

export const createAverageRating = (
  rate,
  iconStyle = { height: 64, width: 64 }
) => {
  if (rate >= 3.5) return <Star color="primary" sx={iconStyle} />;

  if (rate <= 3.49 && rate >= 1.5)
    return <StarHalfIcon color="primary" sx={iconStyle} />;

  return <StarBorder color="primary" sx={iconStyle} />;
};

export const getAverageRating = (ratings) => {
  let average = 0;

  const ratingLabel = [
    'courseRating',
    'infrastructureRating',
    'schoolRating',
    'teachingMethodologyRating',
  ];

  ratingLabel.forEach((label) => {
    average += ratings[label];
  });

  return average / ratingLabel.length;
};

export const categorySlug = {
  1: 'Bronze',
  2: 'Silver',
  3: 'Gold',
};

export const switchCommissionBackground = (category) => {
  switch (category) {
    case 'A':
      return green.A700;

    case 'B':
      return cyan[300];

    case 'C':
      return yellow[800];

    case 'D':
      return orange[800];

    default:
      return grey[400];
  }
};

export const categoriesSlugInfo = {
  1: 'Escola econômica para caber no seu bolso',
  2: 'Escola com bom custo benefício',
  3: 'Escola reconhecida com alta qualidade',
};

export const scrollIntoPrices = () => {
  const target = document.querySelector('#builder');

  if (target) {
    target.scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
    });
  }
};

export const getSkeletonsThumb = () => {
  const result = [];

  for (let i = 0; i < 5; i++) result.push(<SkeletonThumb />);

  return result;
};

export function abroadDateSanitization(date) {
  if (!isValidDate(new Date(date))) {
    const startDate = formatDate(
      getNextBusinessDayInRange(
        getDaysAdded(new Date(), parseInt(process.env.DAYS_BEFORE_BOOKING, 10))
      ),
      'iso-string'
    );

    return startDate;
  }

  const groupedMondayOptions = getGroupedMondayOptions(
    formatDate(new Date(date), 'iso-string')
  );
  const isCorrectBusinessDate = groupedMondayOptions.some(
    (m) =>
      formatDate(new Date(m.dates[0].value), 'iso-string') ===
      formatDate(new Date(date), 'iso-string')
  );

  if (!isCorrectBusinessDate) {
    const startDate = formatDate(
      getNextBusinessDayInRange(new Date(date)),
      'iso-string'
    );
    return startDate;
  }
  return date;
}
